import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, ShoppingCart } from "lucide-react";

interface POSProtectedRouteProps {
  children: React.ReactNode;
}

// PDV-2: o bypass do modo terminal anon (quiosque) morreu — /pdv exige
// usuário autenticado SEMPRE.
export function POSProtectedRoute({ children }: POSProtectedRouteProps) {
  const { user, company, loading: authLoading } = useAuth();

  // Aguarda o AuthContext carregar completamente (user E company)
  if (authLoading || (user && !company)) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-secondary/10 flex flex-col items-center justify-center gap-4">
        <div className="relative">
          <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full animate-pulse" />
          <div className="relative bg-card p-6 rounded-2xl shadow-xl border border-border/50">
            <ShoppingCart className="h-12 w-12 text-primary animate-pulse" />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Loader2 className="h-5 w-5 animate-spin text-primary" />
          <span className="text-muted-foreground font-medium">Carregando PDV...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/pdv-auth" replace />;
  }

  return <>{children}</>;
}
